import request from '@/util/request';

// 获取老人情况统计
export const getElderStatistics = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getElderStatistics',
    Object.assign({}, options, { params })
  );

// 获取老人性别统计
export const getElderSexStatistics = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getElderSexStatistics',
    Object.assign({}, options, { params })
  );

// 获取老人年龄统计
export const getElderAgeStatistics = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getElderAgeStatistics',
    Object.assign({}, options, { params })
  );

// 获取床位统计
export const getBedStatistics = (params, options) =>
  request.get('/api/v4ward/nursing/index/getBedStatistics', Object.assign({}, options, { params }));

// 获取设备类型统计
export const getDeviceTypeStatistics = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getDeviceTypeStatistics',
    Object.assign({}, options, { params })
  );

// 获取最近5次的活动信息
export const getLastActivityInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getLastActivityInfo',
    Object.assign({}, options, { params })
  );
